import omit from 'lodash/fp/omit';

export default (state = {}, action: any) => {
  const { type } = action;
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE|CLEAR)/.exec(type);

  if (!matches) return state;

  const [, requestName, requestState] = matches;

  if (requestState === 'CLEAR') {
    return {
      ...omit([`${requestName}_state`], state),
    };
  }

  return {
    ...state,
    [requestName]: requestState === 'REQUEST',
    [`${requestName}_state`]: requestState,
  };
};
